import { UseFormBehaviors_ValidationFnType } from 'hooks/useFormBehaviors/useFormBehaviors.types';
import { FormValidationErrorMessageType } from '@awais4123/fillify-design-library/lib/common.types';
import { isString } from 'types/common.types';
import { ITeamMemberViewForm } from 'components/InviteTeamMembersByCSVModal/views/InviteTeamMemberView/InviteTeamMemberView.form.context';
import i18next from 'i18next';
import { IBKJComboBoxOption } from '@awais4123/fillify-design-library/lib/components/BKJComboBox/BKJComboBox.types';
import { DateTime } from 'luxon';
export interface ComboBoxOption {
  key: string;
  id: string;
  value: string;
  label: string;
}
export const employmentStatuses = (): Omit<
  IBKJComboBoxOption<string, string, string | number>,
  'index'
>[] => [
  {
    id: 'full_time',
    label: i18next.t('groups:FULL_TIME'),
    value: 'Full Time',
    name: 'employmentStatuses',
    key: 'full_time',
  },
  {
    id: 'part_time',
    label: i18next.t('groups:PART_TIME'),
    value: 'Part Time',
    name: 'employmentStatuses',
    key: 'part_time',
  },
  {
    id: 'casual',
    label: i18next.t('groups:CASUAL'),
    value: 'Casual',
    name: 'employmentStatuses',
    key: 'casual',
  },
  {
    id: 'flex',
    label: i18next.t('groups:FLEX'),
    value: 'Flex',
    name: 'employmentStatuses',
    key: 'flex',
  },
];

export const monthToDaysMap: { [key: string]: string[] } = {};
for (let month = 1; month < 13; month++) {
  const monthName = DateTime.fromFormat('2000-01-01', 'yyyy-MM-dd').set({ month }).toFormat('LLLL');
  const daysInMonth = Array.from(
    { length: DateTime.fromFormat('2000-01-01', 'yyyy-MM-dd').set({ month }).daysInMonth || 0 },
    (_, i) => (i + 1).toString(),
  );

  monthToDaysMap[monthName] = daysInMonth;
}

export const VALIDATION_required = (value: string) => {
  if (value.length === 0 || !value[0]) {
    return i18next.t(`team_member:MANDATORY_FIELD`);
  }
  return '';
};
export const VALIDATION_position_id: UseFormBehaviors_ValidationFnType<ITeamMemberViewForm> = (
  value,
): string => {
  const position_id = value as string[];
  if (position_id.length === 0) return i18next.t(`team_member:MANDATORY_FIELD`);
  return '';
};

export const convertEmploymentStatus = (employmentStatus: string) => {
  const convertedEmploymentStatus = employmentStatus.replace(' ', '_').toLowerCase();
  let employmentStatusValue;
  switch (convertedEmploymentStatus) {
    case 'p':
      employmentStatusValue = 'part_time';
      break;
    case 'f':
      employmentStatusValue = 'full_time';
      break;
    case 'c':
      employmentStatusValue = 'casual';
      break;
    default:
      employmentStatusValue = convertedEmploymentStatus;
  }
  return employmentStatusValue;
};

function validateEmail(email: string) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

export const VALIDATION_email = (value: unknown): FormValidationErrorMessageType => {
  const messages: FormValidationErrorMessageType = [];

  if (isString(value)) {
    if (value.length === 0) return messages.concat(i18next.t(`team_member:MANDATORY_FIELD`));

    if (!validateEmail(value))
      messages.push(i18next.t(`team_member:PLEASE_MAKE_SURE_EMAIL_CORRECT_FORMAT`));
  }
  return messages;
};

export const VALIDATION_phoneNumber = (value: unknown): FormValidationErrorMessageType => {
  const messages: FormValidationErrorMessageType = [];

  if (isString(value)) {
    if (value.length === 0) return messages.concat(i18next.t(`team_member:MANDATORY_FIELD`));
    // Remove non-digit characters from the phone number
    const digitsOnly = value.replace(/\D/g, '');
    if (!/^\d{11}$/.test(digitsOnly)) {
      messages.push(i18next.t('team_member:PLEASE_MAKE_SURE_PHONE_NUMBER_IS_BETWEEN'));
    }
  }

  return messages;
};

interface ApiError {
  phone: string;
  email: string;
}

export interface InviteTeamMemberFormApiError {
  data?: ApiError[];
}

export const monthNameToNumber: { [key: string]: number } = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};
